var _rect, _rect2, _path, _mask, _path2, _path3, _rect3, _rect4, _g, _rect5, _rect6, _path4, _path5, _mask2, _path6, _path7, _rect7, _rect8, _g2, _rect9, _rect10, _path8, _path9, _mask3, _path10, _path11, _rect11, _rect12, _g3, _rect13, _rect14, _path12, _path13, _mask4, _path14, _path15, _rect15, _rect16, _g4, _rect17, _rect18, _path16, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockedThumbnailSection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1288,
    height: 355,
    viewBox: "0 0 1288 355",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1288,
    height: 355,
    rx: 10,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 24.3008,
    width: 1224,
    height: 14.4,
    rx: 4,
    fill: "#E4E4E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 71C32 64.3726 37.3726 59 44 59H314C320.627 59 326 64.3726 326 71V239H32V71Z",
    fill: "#EFEFFF"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_23251_19620",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 239H326V323C326 329.627 320.627 335 314 335H44C37.3726 335 32 329.627 32 323V239Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 239H326V323C326 329.627 320.627 335 314 335H44C37.3726 335 32 329.627 32 323V239Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 239H326H32ZM327 323C327 330.18 321.18 336 314 336H44C36.8203 336 31 330.18 31 323H33C33 329.075 37.9249 334 44 334H314C320.075 334 325 329.075 325 323H327ZM44 336C36.8203 336 31 330.18 31 323V239H33V323C33 329.075 37.9249 334 44 334V336ZM327 239V323C327 330.18 321.18 336 314 336V334C320.075 334 325 329.075 325 323V239H327Z",
    fill: "#E4E4E4",
    mask: "url(#path-4-inside-1_23251_19620)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 263.5,
    width: 190,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 280.301,
    width: 190,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23251_19620)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 305.801,
    width: 232,
    height: 10.4,
    rx: 4,
    fill: "#E4E4E4"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 276.5,
    y: 257.5,
    width: 31,
    height: 31,
    rx: 5.5,
    fill: "#ECECEC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 276.5,
    y: 257.5,
    width: 31,
    height: 31,
    rx: 5.5,
    stroke: "#E4E4E4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M287.75 271C288.44 271 289 271.56 289 272.25C289 272.94 288.44 273.5 287.75 273.5C287.06 273.5 286.5 272.94 286.5 272.25C286.5 271.56 287.06 271 287.75 271ZM292.75 271C293.44 271 294 271.56 294 272.25C294 272.94 293.44 273.5 292.75 273.5C292.06 273.5 291.5 272.94 291.5 272.25C291.5 271.56 292.06 271 292.75 271ZM297.75 271C298.44 271 299 271.56 299 272.25C299 272.94 298.44 273.5 297.75 273.5C297.06 273.5 296.5 272.94 296.5 272.25C296.5 271.56 297.06 271 297.75 271Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M342 71C342 64.3726 347.373 59 354 59H624C630.627 59 636 64.3726 636 71V239H342V71Z",
    fill: "#EFEFFF"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-2_23251_19620",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342 239H636V323C636 329.627 630.627 335 624 335H354C347.373 335 342 329.627 342 323V239Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M342 239H636V323C636 329.627 630.627 335 624 335H354C347.373 335 342 329.627 342 323V239Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M342 239H636H342ZM637 323C637 330.18 631.18 336 624 336H354C346.82 336 341 330.18 341 323H343C343 329.075 347.925 334 354 334H624C630.075 334 635 329.075 635 323H637ZM354 336C346.82 336 341 330.18 341 323V239H343V323C343 329.075 347.925 334 354 334V336ZM637 239V323C637 330.18 631.18 336 624 336V334C630.075 334 635 329.075 635 323V239H637Z",
    fill: "#E4E4E4",
    mask: "url(#path-12-inside-2_23251_19620)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 263.5,
    width: 190,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 280.301,
    width: 190,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_23251_19620)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 305.801,
    width: 232,
    height: 10.4,
    rx: 4,
    fill: "#E4E4E4"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 586.5,
    y: 257.5,
    width: 31,
    height: 31,
    rx: 5.5,
    fill: "#ECECEC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 586.5,
    y: 257.5,
    width: 31,
    height: 31,
    rx: 5.5,
    stroke: "#E4E4E4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M597.75 271C598.44 271 599 271.56 599 272.25C599 272.94 598.44 273.5 597.75 273.5C597.06 273.5 596.5 272.94 596.5 272.25C596.5 271.56 597.06 271 597.75 271ZM602.75 271C603.44 271 604 271.56 604 272.25C604 272.94 603.44 273.5 602.75 273.5C602.06 273.5 601.5 272.94 601.5 272.25C601.5 271.56 602.06 271 602.75 271ZM607.75 271C608.44 271 609 271.56 609 272.25C609 272.94 608.44 273.5 607.75 273.5C607.06 273.5 606.5 272.94 606.5 272.25C606.5 271.56 607.06 271 607.75 271Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M652 71C652 64.3726 657.373 59 664 59H934C940.627 59 946 64.3726 946 71V239H652V71Z",
    fill: "#EFEFFF"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-20-inside-3_23251_19620",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M652 239H946V323C946 329.627 940.627 335 934 335H664C657.373 335 652 329.627 652 323V239Z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M652 239H946V323C946 329.627 940.627 335 934 335H664C657.373 335 652 329.627 652 323V239Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M652 239H946H652ZM947 323C947 330.18 941.18 336 934 336H664C656.82 336 651 330.18 651 323H653C653 329.075 657.925 334 664 334H934C940.075 334 945 329.075 945 323H947ZM664 336C656.82 336 651 330.18 651 323V239H653V323C653 329.075 657.925 334 664 334V336ZM947 239V323C947 330.18 941.18 336 934 336V334C940.075 334 945 329.075 945 323V239H947Z",
    fill: "#E4E4E4",
    mask: "url(#path-20-inside-3_23251_19620)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 670,
    y: 263.5,
    width: 190,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 670,
    y: 280.301,
    width: 190,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_23251_19620)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 670,
    y: 305.801,
    width: 232,
    height: 10.4,
    rx: 4,
    fill: "#E4E4E4"
  }))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 896.5,
    y: 257.5,
    width: 31,
    height: 31,
    rx: 5.5,
    fill: "#ECECEC"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 896.5,
    y: 257.5,
    width: 31,
    height: 31,
    rx: 5.5,
    stroke: "#E4E4E4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M907.75 271C908.44 271 909 271.56 909 272.25C909 272.94 908.44 273.5 907.75 273.5C907.06 273.5 906.5 272.94 906.5 272.25C906.5 271.56 907.06 271 907.75 271ZM912.75 271C913.44 271 914 271.56 914 272.25C914 272.94 913.44 273.5 912.75 273.5C912.06 273.5 911.5 272.94 911.5 272.25C911.5 271.56 912.06 271 912.75 271ZM917.75 271C918.44 271 919 271.56 919 272.25C919 272.94 918.44 273.5 917.75 273.5C917.06 273.5 916.5 272.94 916.5 272.25C916.5 271.56 917.06 271 917.75 271Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M962 71C962 64.3726 967.373 59 974 59H1244C1250.63 59 1256 64.3726 1256 71V239H962V71Z",
    fill: "#EFEFFF"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-28-inside-4_23251_19620",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M962 239H1256V323C1256 329.627 1250.63 335 1244 335H974C967.373 335 962 329.627 962 323V239Z"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M962 239H1256V323C1256 329.627 1250.63 335 1244 335H974C967.373 335 962 329.627 962 323V239Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M962 239H1256H962ZM1257 323C1257 330.18 1251.18 336 1244 336H974C966.82 336 961 330.18 961 323H963C963 329.075 967.925 334 974 334H1244C1250.08 334 1255 329.075 1255 323H1257ZM974 336C966.82 336 961 330.18 961 323V239H963V323C963 329.075 967.925 334 974 334V336ZM1257 239V323C1257 330.18 1251.18 336 1244 336V334C1250.08 334 1255 329.075 1255 323V239H1257Z",
    fill: "#E4E4E4",
    mask: "url(#path-28-inside-4_23251_19620)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 980,
    y: 263.5,
    width: 190,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 980,
    y: 280.301,
    width: 190,
    height: 11.2,
    rx: 4,
    fill: "#E4E4E4"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_23251_19620)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 980,
    y: 305.801,
    width: 232,
    height: 10.4,
    rx: 4,
    fill: "#E4E4E4"
  }))), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 1206.5,
    y: 257.5,
    width: 31,
    height: 31,
    rx: 5.5,
    fill: "#ECECEC"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 1206.5,
    y: 257.5,
    width: 31,
    height: 31,
    rx: 5.5,
    stroke: "#E4E4E4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1217.75 271C1218.44 271 1219 271.56 1219 272.25C1219 272.94 1218.44 273.5 1217.75 273.5C1217.06 273.5 1216.5 272.94 1216.5 272.25C1216.5 271.56 1217.06 271 1217.75 271ZM1222.75 271C1223.44 271 1224 271.56 1224 272.25C1224 272.94 1223.44 273.5 1222.75 273.5C1222.06 273.5 1221.5 272.94 1221.5 272.25C1221.5 271.56 1222.06 271 1222.75 271ZM1227.75 271C1228.44 271 1229 271.56 1229 272.25C1229 272.94 1228.44 273.5 1227.75 273.5C1227.06 273.5 1226.5 272.94 1226.5 272.25C1226.5 271.56 1227.06 271 1227.75 271Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23251_19620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 232,
    height: 12,
    fill: "white",
    transform: "translate(50 305)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_23251_19620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 232,
    height: 12,
    fill: "white",
    transform: "translate(360 305)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_23251_19620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 232,
    height: 12,
    fill: "white",
    transform: "translate(670 305)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_23251_19620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 232,
    height: 12,
    fill: "white",
    transform: "translate(980 305)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedThumbnailSection);
export default __webpack_public_path__ + "static/media/locked_thumbnail_section.05003a277f16baf46036eba325f5563b.svg";
export { ForwardRef as ReactComponent };